export default function scrollBehavior(to, from, savedPosition) {
  if (to && to.hash) {
    return {
      selector: to.hash,
    };
  }
  if (savedPosition) {
    return savedPosition;
  }
  return { x: 0, y: 0 };
}
